export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14337.1113ef80.jpg";